import { render, staticRenderFns } from "./GiftsHospitalityHub.vue?vue&type=template&id=cb7730e6&"
import script from "./GiftsHospitalityHub.vue?vue&type=script&lang=js&"
export * from "./GiftsHospitalityHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports